import { ThemeTypes } from "app/core/theme/theme-types";
import { IconNames } from "app/shared/models/icon-names.interface";
import { O2_ICONS } from "app/shared/constants/icons-lists/icons-list-o2";

export const COMMON_ICONS_LIST: IconNames = {
  add: "icon_add_solid_black",
  address_book: "icon_address_book_outline_black",
  apps: "icon_apps_solid_black",
  arrow_down: "icon_arrow_down_solid_black",
  arrow_down_long: "icon_arrow_down_long_solid_black",
  arrow_dropdown: "icon_arrow_dropdown_solid_black",
  arrow_left: "icon_arrow_left_solid_black",
  arrow_left_long: "icon_arrow_left_long_solid",
  arrow_right: "icon_arrow_right_solid_black",
  arrow_right_long: "icon_arrow_right_long_solid_black",
  arrow_up: "icon_arrow_up_solid_black",
  arrow_up_long: "icon_arrow_up_long_solid_black",
  attention: "icon_attention_outline_black",
  attention_solid: "icon_attention_solid_black",
  backspace: "icon_backspace_solid_black",
  backup_number: "icon_ndaks_solid_black",
  banned: "icon_banned_solid_black",
  bfl_view: "icon_bfl_outline_black",
  calendar_outline: "icon_calendar_outline_black",
  calendar_solid: "icon_calendar_solid_black",
  call: "icon_call_solid",
  call_drop_area: "icon_call_drop_area",
  call_end: "icon_call_end_solid_black",
  call_forwarding: "icon_call_forwarding_solid_black",
  call_forwarding_busy: "icon_call_forwarding_busy_solid_black",
  call_forwarding_no_answer: "icon_call_forwarding_no_answer_solid_black",
  call_forwarding_unconditional:
    "icon_call_forwarding_unconditional_solid_black",
  call_hold: "icon_call_hold_solid_black",
  call_incoming: "icon_call_incoming_solid_black",
  call_missed: "icon_call_missed_solid_black",
  call_modal: "icon_add_solid_black",
  call_outgoing: "icon_call_outgoing_solid_black",
  call_pull_desktop: "icon_call_pull_desktop_solid_black",
  call_round: "icon_call_outline_black",
  cdr: "icon_cdr_solid_black",
  center: "icon_center",
  checkbox_checked: "icon_checkbox_checked_solid_black",
  checkbox_unchecked: "icon_checkbox_unchecked_solid_black",
  cinema_mode_off: "icon_cinema_mode_off_solid_black",
  cinema_mode_on: "icon_cinema_mode_on_solid_black",
  clipboard: "icon_clipboard_solid_black",
  close: "icon_close_solid",
  close_round: "icon_close_round_solid_black",
  cloudya: "icon_cloudya_solid_black",
  company: "icon_company_solid_black",
  conference_call_outline: "icon_confernce_call_outline_black",
  conference_call_solid: "icon_conference_call_solid_black",
  conference_phone_outline: "icon_conference_phone_outline_black",
  conference_phone_solid: "icon_conference_phone_solid_black",
  contact: "icon_contact_solid_black",
  contact_add: "icon_contact_add_solid_black",
  contact_call: "icon_contact_call",
  crop_video_solid: "icon_crop_video_solid_black",
  crown: "icon_crown_solid_black",
  delete: "icon_delete_solid_black",
  dialpad: "icon_dialpad_solid",
  disabled: "icon_disabled_solid_black",
  document: "icon_document_solid_black",
  done: "icon_done_solid_black",
  download: "icon_download_solid",
  duplicate: "icon_duplicate_solid_black",
  easy_handling: "icon_easy_handling_solid_black",
  edit: "icon_edit_solid_black",
  email: "icon_email_solid_black",
  emergency_cross: "icon_emergency_cross_solid_white",
  extension: "icon_extension_solid_black",
  external_link: "icon_external_link_solid",
  expand: "icon_expand_solid_black",
  face_to_face: "icon_face_to_face_solid_black",
  favorite: "icon_favorite_solid_black",
  fax_in: "icon_fax_in_solid_black",
  fax_out: "icon_fax_out_solid_black",
  fax_outline: "icon_fax_outline_black",
  fax_solid: "icon_fax_solid",
  filter: "icon_filter_solid",
  fit_video_solid: "icon_fit_video_solid_black",
  fit_to_screen: "icon_fit_to_screen",
  fullscreen_off: "icon_fullscreen_off_solid_black",
  fullscreen_on: "icon_fullscreen_on_solid_black",
  function_code: "icon_function_code_solid_black",
  gallery: "icon_gallery_view_solid_black",
  group: "icon_group_solid_black",
  headset: "icon_headset-solid-black",
  inactive: "icon_inactive",
  info: "icon_information_outline_black",
  ivr: "icon_ivr_solid_black",
  keyboard: "icon_keyboard_solid_black",
  list: "icon_list_view_solid_black",
  lock_closed: "icon_lock_solid_black",
  lock_open: "icon_unlock_solid_black",
  logout: "icon_logout_solid_black",
  lower_all_hands: "icon_lower_all_hands_solid_black",
  lower_hand: "icon_lower_hand_solid_black",
  menu_horizontal: "icon_menu_horizontal_solid_black",
  menu_vertical: "icon_menu_vertical_solid_black",
  mic_all_off: "icon_mic_all_off_solid_black",
  mic_all_on: "icon_mic_all_on_solid_black",
  mic_off: "icon_mic_off_solid_black",
  mic_on: "icon_mic_on_solid_black",
  moderator: "icon_moderator_solid_black",
  nav: "icon_nav_solid_black",
  order_solid: "icon_order_solid",
  pause: "icon_pause_solid",
  pin: "icon_pin_solid_black",
  play: "icon_play_solid_black",
  queue: "icon_queues_solid_black",
  raise_hand: "icon_raise_hand_active_solid_black",
  ringing_off: "icon_ringing_off_solid_black",
  ringing_on: "icon_ringing_on_solid_black",
  rotate: "icon_rotate",
  screen_sharing: "icon_screen_sharing_on_solid_black",
  search: "icon_search_solid_black",
  service: "icon_service_solid_black",
  settings_outline: "icon_settings_outline_black",
  settings_solid: "icon_settings_solid",
  skill: "icon_skill_solid_black",
  speed_dial: "icon_speed_dial_solid_black",
  time: "icon_time_outline_black",
  time_solid: "icon_time_solid_black",
  timer: "icon_timer_solid_black",
  transfer: "icon_transfer_solid_black",
  tune: "icon_tune_solid_black",
  unpin: "icon_unpin_solid_black",
  upload_file: "icon_upload_solid_black",
  video_off: "icon_video_off_solid_black",
  video_on: "icon_video_on_solid_black",
  voicemail: "icon_voicemail_solid",
  voicemail_forward: "icon_voicemail_solid_black",
  voicemail_forward_solid: "icon_voicemail_forward_solid_black",
  volume_low: "icon_volume_low_solid_black",
  volume_on: "icon_volume_on_solid_black",
  world: "icon_world_solid_black",
  pickup: "icon_pickup_call_solid_black",
  eye_visible: "icon_eye_visible_black",
  eye_hidden: "icon_eye_hiden_black",
  camera: "icon_camera_solid_black",
  reactions: "icon_reactions",
};

export const THEMES_ICONS_LIST: { [theme: string]: Partial<IconNames> } = {
  [ThemeTypes.O2SIPTrunkTheme]: O2_ICONS,
};
